export default "__VITE_ASSET__BHqQNzVI__"